/**
 * React Query hooks for user settings
 */

import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../contexts/AuthContext';
import { apiFetch } from '../lib/api';

export interface UserSettings {
  visibility: 'public' | 'friends' | 'private';
  activity_visibility_enabled: boolean;
  allow_recommendations: 'followers' | 'none';
  show_in_search: boolean;
}

/**
 * Get user's privacy settings
 * Inherits global staleTime (60s) and refetchOnMount (false).
 * Freshness driven by mutation invalidation + refetchOnWindowFocus.
 */
export function useSettingsQuery() {
  const { user, session } = useAuth();
  const token = session?.access_token;

  return useQuery({
    queryKey: ['settings', user?.id],
    enabled: !!user && !!token,
    queryFn: async ({ signal }) => {
      return apiFetch<UserSettings>('/user/settings', { token, signal });
    },
    refetchOnWindowFocus: true,
  });
}
